import React, { useEffect, useRef, useState } from 'react'
import Button from '../common/button/Button'
import SearchInput from '../common/search-input/SearchInput'
import CustModal from '../common/custmodal/CustModal'
import UserName from '../common/user/UserName'
import Loader from '../common/loader/Loader'
import PlusIcon from '../svgIcons/PlusIcon'
import MageDotsIcon from '../svgIcons/MageDotsIcon'


import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { AppDispatch, IRootState } from '../../redux/rootReducer'
import { deleteRole, getRolesList } from '../../redux/roles/actions/roles.action'
import { useSelector } from 'react-redux'
import Toast from '../common/toast/Toast'
import moment from 'moment'
import { useDebounce } from '../../utils/useDebounce'
import { RoleModalContent } from './AddRole'
import styles from './Roles.module.css'

export type ToastType = 'error' | 'success';

export interface RoleProps {
    id: string;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
}

const Roles = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showActionBox, setShowActionBox] = useState<string | null>(null);
    const [actionBoxPosition, setActionBoxPosition] = useState<'top' | 'bottom'>('bottom');
    const actionButtonRefs = useRef<Record<string, HTMLTableRowElement | null>>({});
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState<RoleProps | null>(null);
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState<ToastType | null>(null);
    const [toastMessage, setToastMessage] = useState<string | null>(null);
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const searchWithDebounce = useDebounce(searchTerm, 1000);
    const [roleLoading, setRoleLoading] = useState(false);

    const { data: rolesList, loading: rolesListLoading } = useSelector((state: IRootState) => state.rolesListReducer);

    const onRoleSuccess = () => {
        dispatch(getRolesList(searchWithDebounce || null))
    }

    const handleActionButtonClick = (index: string) => {
        const rowRef = actionButtonRefs.current[index];

        if (rowRef) {
            const rect = rowRef.getBoundingClientRect();
            const parentRect = rowRef.closest(`.${CSS.escape(styles.tableListing)}`)?.getBoundingClientRect();

            if (parentRect) {
                const parentBottom = parentRect.bottom;
                if (rect.bottom > parentBottom - 100) {
                    setActionBoxPosition('top');
                } else {
                    setActionBoxPosition('bottom');
                }
                setShowActionBox(showActionBox !== index ? index : '');
            }
        }
    };

    const onNewRoleSuccess = (message: string) => {
        setSelectedId(null);
        setRoleLoading(false)
        setToastType('success');
        setShowToast(true);
        setToastMessage(message);
        setShowModal(false);
        dispatch(getRolesList(searchWithDebounce || null));
    }

    const onNewRoleFailure = (message: string) => {
        setRoleLoading(false)
        setToastType('error');
        setShowToast(true);
        setToastMessage(message)
    }

    const onDeleteRole = () => {
        if (selectedId?.id) {
            setRoleLoading(true)
            setShowConfirmModal(false)
            dispatch(deleteRole(selectedId?.id, onNewRoleSuccess, onNewRoleFailure))
        }
    }

    useEffect(() => {
        dispatch(getRolesList(searchWithDebounce || null));
    }, [searchWithDebounce]);

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    const ActionModalBody = () => {
        return (
            <div className={styles.actionModal}>
                <h2 className={styles.title}>{`Are you sure you want to delete?`}</h2>
                <p className={styles.description}>
                    Role cannot be recovered once deleted.
                </p>
                <div className={styles.actions}>
                    <button disabled={isLoading} className={styles.cancelButton} onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </button>
                    <button disabled={isLoading} className={styles.confirmButton}
                        onClick={onDeleteRole}>
                        Delete
                    </button>
                </div>
            </div >
        )
    }

    return (
        <div className={styles.pageContainer}>
            {(isLoading || rolesListLoading || roleLoading) && <Loader />}
            <div className={styles.pageHeader}>
                <div className={styles.leftContainer}>
                    <p className={styles.userGreet}>
                        Welcome, <UserName />
                    </p>

                    <h3>Roles & Permission</h3>
                </div>

                <div className={styles.rightContainer}>
                    <SearchInput
                        value={searchTerm}
                        placeholder='Search Role'
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ width: 264 }}
                    />

                    <Button variant='green' onClick={() => {
                        setSelectedId(null)
                        setShowModal(true);
                    }}>
                        <PlusIcon />
                        <span>Add</span>
                    </Button>
                </div>
            </div>

            <div className={styles.tableContainer}>
                <div className={styles.tableListing}>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Created On</th>
                                <th>Updated On</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(rolesList && rolesList?.length > 0 && !rolesListLoading) ? rolesList.map((role: RoleProps, index: number) => {
                                return <tr
                                    key={index}
                                    ref={(ref) => (actionButtonRefs.current[role?.id] = ref)}
                                >
                                    <td style={{ textTransform: 'capitalize' }}>{role?.name}</td>
                                    <td>{role?.description || ''}</td>
                                    <td>{moment(role?.created_at).format('MM-DD-YYYY HH:MM A')}</td>
                                    <td>{moment(role?.updated_at).format('MM-DD-YYYY HH:MM A')}</td>
                                    <td>
                                        {!!showActionBox && <div className={styles.dropDownBackDrop} onClick={() => setShowActionBox('')}></div>}
                                        <div className={styles.actionButtonWrapper}>

                                            <button className={styles.MageDotsIcon}
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                                    event.stopPropagation();
                                                    handleActionButtonClick(role?.id)
                                                }}
                                            >
                                                <MageDotsIcon />
                                            </button>
                                            <div className={`${styles.actionContainer} ${role?.id === showActionBox ? styles.active : ''} ${actionBoxPosition === 'top' ? styles.top : ''}`}>
                                                <div className={styles.actionBox} role='button' onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                    event.stopPropagation();
                                                    setSelectedId(role);
                                                    setShowModal(true)
                                                    setShowActionBox(null)
                                                }}>
                                                    <span>{'Edit'}</span>
                                                </div>
                                                <div className={styles.actionBox} role='button' onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                    event.stopPropagation();
                                                    navigate(`/role-permission/${role?.id}`)
                                                }}>
                                                    <span>{'Permissions'}</span>
                                                </div>

                                                <div className={styles.actionBox} role='button' onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                    event.stopPropagation();
                                                    setSelectedId(role)
                                                    setShowConfirmModal(true);
                                                    setShowActionBox(null)
                                                }}>
                                                    <span>{'Remove'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                </tr>
                            })
                                : !rolesListLoading &&
                                <tr>
                                    <td style={{ textAlign: 'center' }} colSpan={4}>No Roles Found</td>
                                </tr>
                            }

                        </tbody>
                    </table>
                </div>

                {/* <Pagination
                    className="pagination-bar"
                    currentPage={1}
                    totalCount={15}
                    pageSize={1}
                // onPageChange={(page: number) => {
                //     setCurrentPage(page);
                //     requestNewData(page);
                // }}
                /> */}
            </div >

            <CustModal
                className="custom-import-modal"
                open={showModal}
                setOpen={setShowModal}
                bodyData={<RoleModalContent setShowModal={setShowModal}
                    selectedId={selectedId}
                    setShowToast={setShowToast}
                    setToastMessage={setToastMessage}
                    setToastType={setToastType}
                    setSelectedId={setSelectedId}
                    onSuccess={onRoleSuccess} />}
                shouldCloseOnOverLay={false}
            />
            {showToast && <Toast type={toastType || 'error'} message={toastMessage || ''} />}
            <CustModal
                open={showConfirmModal}
                bodyData={<ActionModalBody />}
                onCloseModal={() => {
                    setSelectedId(null)
                    setShowConfirmModal(false)
                }} />
        </div >
    )
}

export default Roles
